import {
  SelectedWorkcellId,
  isSelectedWorkcellId,
} from '../../hooks/useGetWorkcell/types';
import { LoadedWorkflowV3 } from '../migrateTo3';

export type LoadedWorkflowV4 = LoadedWorkflowV3 & {
  selectedWorkcellId: SelectedWorkcellId;
};

export const _migrateTo4 = (
  loadedWorkflow: LoadedWorkflowV3
): LoadedWorkflowV4 => {
  const selectedWorkcellId =
    localStorage.getItem('selectedWorkcellId') ?? 'azProd';

  if (isSelectedWorkcellId(selectedWorkcellId) === false) {
    throw new Error(
      `Invalid selectedWorkcellId found during migration to v4: ${selectedWorkcellId}`
    );
  }

  return {
    ...loadedWorkflow,
    selectedWorkcellId,
  };
};
